import { gql } from "apollo-boost";

const REORDER_PRODUCT_VARIANTS = gql`
  mutation reorderProductVariants($input: ReorderProductVariants) {
    reorderProductVariants(input: $input) {
      data
      status
      error
    }
  }
`;

export default REORDER_PRODUCT_VARIANTS;
